import React from "react";
import { ArrowLeft, ArrowRight, Save, Send } from "lucide-react";

export default function ActionBar({ onBack, onDraft, onNext, isPreview, backDisabled, nextLabel, draftSaved }) {
  return (
    <div className="no-print sticky bottom-0 left-0 right-0 z-40 mt-2 border-t-2 border-[#E0A106]/40 bg-[#fbf9f2]/95 backdrop-blur">
      {draftSaved && (
        <div className="px-4 pt-2 text-[13px] font-medium text-[#3a6b1c]">प्रारूप सर्व्हरवर जतन झाले ✓</div>
      )}
      <div className="flex flex-wrap items-center justify-between gap-2 px-4 py-3">
        <button
          type="button"
          onClick={onBack}
          disabled={backDisabled}
          className="flex items-center gap-1.5 rounded-full border border-[#1b5e3f]/40 bg-white px-5 py-2 text-[14px] font-semibold text-[#1b5e3f] transition-all hover:bg-[#1b5e3f]/5 disabled:cursor-not-allowed disabled:opacity-40"
        >
          <ArrowLeft className="h-4 w-4" /> मागे जा
        </button>
        <button
          type="button"
          onClick={onDraft}
          className="flex items-center gap-1.5 rounded-full border-[1.5px] border-[#E0A106] bg-[#fdf7e5] px-5 py-2 text-[14px] font-semibold text-[#b8790a] transition-all hover:bg-[#fbeecb]"
        >
          <Save className="h-4 w-4" /> प्रारूप जतन करा (Save as Draft)
        </button>
        {isPreview ? (
          <button
            type="button"
            onClick={onNext}
            className="flex items-center gap-1.5 rounded-full bg-[#5a9e3a] px-6 py-2.5 text-[14px] font-semibold text-white shadow-sm transition-all hover:bg-[#4f8b32] hover:shadow"
          >
            <Send className="h-4 w-4" /> अर्ज सादर करा
          </button>
        ) : (
          <button
            type="button"
            onClick={onNext}
            className="flex items-center gap-1.5 rounded-full bg-[#1b5e3f] px-6 py-2.5 text-[14px] font-semibold text-white shadow-sm transition-all hover:bg-[#164e34] hover:shadow"
          >
            {nextLabel || "पुढे जा"} <ArrowRight className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  );
}
